import { Component, inject } from '@angular/core';
import { AsyncPipe } from '@angular/common';
import { MatButtonModule } from '@angular/material/button';
import { MatIconModule } from '@angular/material/icon';
import { ActivatedRoute, RouterLink } from '@angular/router';
import { map } from 'rxjs';
import { SplUiIcon } from '../../directives';

@Component({
  selector: 'spl-ui-not-found-feature',
  imports: [MatButtonModule, MatIconModule, SplUiIcon, AsyncPipe, RouterLink],
  templateUrl: './not-found.feature.html',
  styleUrl: './not-found.feature.scss',
})
export class SplUiNotFoundFeature {
  private readonly activatedRoute = inject(ActivatedRoute);

  readonly fallbackPath = this.activatedRoute.data.pipe(map(({ fallbackPath }) => fallbackPath));
}
